<template>
  <div>
    <v-card flat>
      <v-data-table
        flat
        :headers="headers"
        :items="groups"
        :expanded="expanded"
        @click:row="clickRow"
        :hide-default-header="true"
        :hide-default-footer="true"
        :items-per-page="-1"
        sortable
        style="background-color: #ecf1f2"
      >
        <template v-slot:body="props">
          <draggable
            animation="300"
            :list="props.items"
            tag="tbody"
            @end="handleDragEnd"
          >
            <tr v-for="(projects, index) in props.items" :key="index">
              <td>
                <customicon /> <span class="px-3">{{ projects.Name }}</span>
              </td>

              <td class="d-flex justify-end">
                <v-icon class="p-0" @click="editItem(projects)">
                  mdi-pencil
                </v-icon>
                <v-icon class="ml-3 mr-2" @click="openDialogDelete(projects)">
                  mdi-delete-outline</v-icon
                >
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>

      <!-----------------edit dialog-------------------------------->
      <v-dialog v-model="Editorganizedialog" persistent max-width="450">
        <v-card v-if="Editorganizedialog">
          <div class="px-8 pt-5 d-flex justify-space-between">
            <h5 class="text_style">Edit Group</h5>
            <v-icon @click="Editorganizedialog = false">mdi-close</v-icon>
          </div>
          <v-card color="#F6F8FC" flat class="py-5 px-8">
            <v-text-field
              :error-messages="
                $v.selectedRowData.Name.$error ? 'Name is required' : null
              "
              clearable
              v-model="selectedRowData.Name"
              label="Name"
            ></v-text-field>
            <b> Permissions </b>
            <br />
            <v-select
              :error-messages="
                $v.selectedRowData.MembershipPermissions.$error
                  ? 'Membership Type is required'
                  : null
              "
              clearable
              :items="getMembership"
              item-text="Name"
              item-value="Id"
              v-model="selectedRowData.MembershipPermissions"
              label="Membership Type"
              multiple
            ></v-select>
            <v-autocomplete
              clearable
              :items="GetCourses"
              v-model="selectedRowData.PrerequisitesCourses"
              multiple
              item-text="Title"
              item-value="Id"
              label="Course Prerequisites"
            ></v-autocomplete>
            <v-select
              clearable
              :items="filterPractitionerList"
              v-model="selectedRowData.PractitionorCertificationLevel"
              label="Practitioner Certification Level"
            ></v-select>
            <v-select
              v-model="selectedRowData.CourseTaughtID"
              :items="GetCourses"
              item-text="Title"
              item-value="Id"
              label="Instructor - Courses Taught"
              clearable
            ></v-select>
          </v-card>
          <v-card-actions class="pb-4 mx-3">
            <v-spacer></v-spacer>
            <v-btn
              class="px-14 py-6 text_style"
              color="grey lighten-1"
              text
              @click="Editorganizedialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              class="px-14 py-6 text_style"
              @click="updateDownloadFileGroup()"
              :disabled="disabledSave"
            >
              <v-progress-circular
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-if="btnloader"
              ></v-progress-circular>
              <span v-else class="pa-4"> Save </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-----------------Delete dialog-------------------------------->
      <v-dialog v-model="dialogDelete" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h5"> Warning </v-card-title>
          <v-card-text class="index_span_2_style"
            >Are you sure you want to delete?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogDelete = false">
              Cancel
            </v-btn>
            <v-btn color="primary" :disabled="btnloader" @click="handleDeleteGroup()">
              <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import customicon from "../../components/Video/costumicon.vue";
import { required } from "vuelidate/lib/validators";
export default {
  name: "simple",
  display: "Simple",
  order: 0,
  components: {
    draggable,
    customicon,
  },
  props: ["groups", "getMembership", "GetInstructors"],
  data() {
    return {
      groupItemId: null,
      selectedRowData: {
        Id: null,
        Name: "",
        MembershipPermissions: [],
        PrerequisitesCourses: null,
        PractitionorCertificationLevel: null,
        CourseTaughtID: null,
      },
      Editorganizedialog: false,
      btnloader: false,
      disabledSave: false,
      dialog: false,
      dialogDelete: false,
      editdialog: false,
      expanded: [],
      filterPractitionerList: ["CBP", "AdvCBP", "CBP-A", "PaRama CBP"],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
        },
        {
          text: "",
          align: "left",
          value: "",
        },
        { text: "", align: "right", value: "actions", sortable: false },
      ],
    };
  },
  validations: {
    selectedRowData: {
      Name: { required },
      MembershipPermissions: { required },
    },
  },
  computed: {
    ...mapGetters(["GetCourses"]),
  },
  mounted() {
  },

  methods: {
    showToast(message) {
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    handleDragEnd(event) {
      const newOrder = event.newIndex; // Get the new index of the dragged item
      const itemId = event.item._underlying_vm_.Id; // Get the ID of the dragged item
      const payload = {
        sortNum: newOrder,
        Id: itemId,
      };
      this.$store.dispatch("SortDownloadFileGroup", payload).then(() => {
        this.$store.dispatch("GetDownloadFileGroups");
      });
    },
    updateDownloadFileGroup() {
      this.$v.selectedRowData.$touch();
      if (this.$v.selectedRowData.$invalid) {
        return;
      } else {
        this.btnloader = true;
        this.disabledSave = true;
        
        let prerequisiteCourseIds = [];
        if (this.selectedRowData.PrerequisitesCourses) {
          prerequisiteCourseIds = this.selectedRowData.PrerequisitesCourses.map(course => {
            return typeof course === 'object' ? course.Id : course;
          });
        }
        const dataToUpdate = {
          Id: this.selectedRowData.Id,
          Name: this.selectedRowData.Name,
          Permissions: this.selectedRowData.MembershipPermissions,
          PrerequisitesCourses: prerequisiteCourseIds,
          PractitionorCertificationLevel: this.selectedRowData
            .PractitionorCertificationLevel
            ? this.selectedRowData.PractitionorCertificationLevel
            : "",
            CourseTaughtID: this.selectedRowData.CourseTaughtID
            ? this.selectedRowData.CourseTaughtID
            : "",
        };
        this.$store
          .dispatch("EditDownloadFileGroups", dataToUpdate)
          .then((res) => {
            this.btnloader = false;
            this.disabledSave = false;
            if (res.Status) {
              this.$store.dispatch("GetDownloadFileGroups");
              this.Editorganizedialog = false;
              this.$emit("show-success-toast");
            } else {
              this.showToast(res.Message);
            }
          })
          .catch((res) => {
            this.btnloader = false;
            this.disabledSave = false;
            this.showToast(res.Message);
          });
      }
    },
    openDialogDelete(item) {
      this.groupItemId = item.Id;
      this.dialogDelete = true;
    },
    handleDeleteGroup() {
      this.btnloader=true;
      const Id = this.groupItemId;
      this.$store.dispatch("DeleteDownloadFileGroups", Id).then((res) => {
        if (res.Status) {
          this.$store.dispatch("GetDownloadFileGroups");
          this.$store.dispatch("GetDownloadfiles");
          this.dialogDelete = false;
          this.btnloader=false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          // this.$emit("show-delete-toast");
        }
      });
    },
    clickRow(item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex((i) => i === item);
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(item);
      }
    },
    editItem(item) {
      this.Editorganizedialog = true;
      this.selectedRowData = { ...item };
    },
    save() {
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
